import { useState, useCallback } from "react";

/**
 * Custom hook for managing toast messages
 */
export const useToast = () => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const setToast = useCallback((visible, message) => {
    setShowToast(visible);
    setToastMessage(message);
  }, []);

  return { showToast, toastMessage, setToast };
};

